export const routes = [
	{
		path: '/',
		redirect: '/home'
	},
	{
		path: '/',
		component: () => import('@/Layout/index.vue'),
		children: [
			{
				path: 'home',
				name: 'home',
				component: () => import('@/views/HomeView/index.vue'),
				meta: {
					title: '',
					current: 0
				}
			},
			{
				path: 'publications',
				name: 'publications',
				component: () => import('@/views/PublicationsView/index.vue'),
				meta: {
					title: '',
					current: 1
				}
			},
			{
				path: 'regulatory',
				name: 'regulatory',
				component: () => import('@/views/PublicationsView/regulatory.vue'),
				meta: {
					title: '',
					current: 1
				}
			},
			{
				path: 'member',
				name: 'member',
				component: () => import('@/views/MemberView/index.vue'),
				meta: {
					title: '',
					current: 2
				}
			},
			{
				path: 'detail',
				name: 'detail',
				component: () => import('@/views/MemberView/detail.vue'),
				meta: {
					title: '',
					current: 2
				}
			},
			{
				path: 'news',
				name: 'news',
				component: () => import('@/views/NewsView/index.vue'),
				meta: {
					title: '',
					current: 3
				}
			},
			{
				path: 'progress',
				name: 'progress',
				component: () => import('@/views/NewsView/progress.vue'),
				meta: {
					title: '',
					current: 3
				}
			},
			{
				path: 'concat',
				name: 'concat',
				component: () => import('@/views/ConcatView/index.vue'),
				meta: {
					title: '',
					current: 4
				}
			}
		]
	}
]
